export default __webpack_public_path__ + "static/media/mp3.5e32500b.svg";